<template>
  <div>
    <modal
      id="limit-reached-modal"
      ref="modalWrapper"
      :hide-backdrop="!isOwner"
      :no-close-on-esc="!isOwner"
      @shown="allowInteraction"
      :no-close-on-backdrop="!isOwner"
      :hide-footer="true" 
      :hide-header="true"
      centered
    >
      <div
        id="hidden-icon"
        v-html="require('!html-loader!images/icons-hidden.svg')"
      ></div>
      <h5 class="limit-reached-modal-title">{{this.title}}</h5>
      <p class="limit-reached-modal-body">{{this.body}}</p>
      <a
        v-if="isOwner"
        id="upgrade-to-unlock"
        data-testid="upgrade-to-unlock"
        href="/plans?utm_source=viewer&utm_campaign=10-views-limit"
        class="btn"
      >
        Upgrade to unlock
      </a>
      <span
        id="already-upgraded"
        v-if="isOwner"
      >
        Already upgraded?<br>
        Contact <a href="mailto:support@getcloudapp.com">support@getcloudapp.com</a>
      </span>
    </modal>
  </div>
</template>

<script>
  import Modal from "@cmp/modal.vue";
  import { mapState } from "vuex";

  export default {
    components: { Modal },
    props: {
      isOwner: {
        type: Boolean, required: true
      }
    },
    mounted() {
      if(this.viewLimitReached){
        this.$refs.modalWrapper.$refs.modal.show()
      }
    },
    methods: {
      allowInteraction: function(){
        // Vue bootstrap makes it really hard to customize stuff like this, doesn't seem like they care.
        // https://github.com/bootstrap-vue/bootstrap-vue/issues/4886
        if(!this.isOwner){ $("#limit-reached-modal___BV_modal_outer_").css("z-index", 0); }
      },
    },
    computed: {
      ...mapState({
        viewLimitReached: state => state.item.attributes.view_limit_reached
      }),
      title: function(){
        return this.isOwner ? "View Limit Reached" : "This item has exceeded its view limit!"
      },
      body: function(){
        return this.isOwner ? "Upgrade now to remove view limit and unlock unlimited views." : "The item owner has been notified that their item has exceeded its view limit."
      }
    }
  }
</script>

<style lang="scss" scoped>
  #limit-reached-modal___BV_modal_outer_.no-owner {
    // allow user menu to be used when is not dismissable
    z-index: 0;
  }

  #upgrade-to-unlock{
    background: linear-gradient(86.52deg, #E4983E 3.34%, #EB6C57 86.48%);
    border: transparent;
    color: white;
    padding: .5rem 1.5rem;
    margin-top: 1.5rem;
  }

  #already-upgraded {
    font-size: .75rem;
    color: #4c6179;
    margin-top: 1rem;
  }

</style>

<style lang="scss">
  // Vue deep selectors don't go well with slots which we use for <modal> component
  // need to style this way.
  #limit-reached-modal___BV_modal_outer_ {
    .modal {
      background-color: rgba(26, 35, 44, .6);
    }

    .modal-content {
      padding: 2.5rem;
      border: none;
      border-radius: .5rem;
    }

    @media screen and (min-width: 576px) {
      .modal-dialog {
        width: 20.5rem;
      }
    }

    .modal-body {
      padding: 0;
      align-items: center;
      display: flex;
      flex-direction: column;
      text-align: center;
    }

    #hidden-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
      width: 3.625rem;
      height: 3.625rem;
      border-radius: 50%;
      background-color: #f0f5f9;
    }

    #hidden-icon svg {
      width: 1.5rem;
      height: 1.5rem;
    }

    .limit-reached-modal-title {
      font-size: 1.25rem;
      line-height: 1.5;
      color: #202529;
      margin-bottom: .5rem;
    }

    .limit-reached-modal-body {
      font-size: .875rem;
      line-height: 1.5;
      margin: 0;
    }
  }
</style>